import { Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import logo from '../../assets/images/logo.png';
import ContactInfo from "../../components/auth/register/ContactInfo";
import EducationInfo from "../../components/auth/register/EducationInfo";
import OtherInfo from "../../components/auth/register/OtherInfo";
import PersonalInfo from "../../components/auth/register/PersonalInfo";
import ProfessionalInfo from "../../components/auth/register/ProfessionalInfo";
import SoftwareExperience from "../../components/auth/register/SoftwareExperience";
import TermsAndCondition from "../../components/suspense/TermsAndCondition";
import { AppContext } from "../../context/AppContext";
import { uploadAdapter } from "../../functions/uploadAdapter";
import { registerUser } from "../../service/AuthService";


const Register = () => {
    const [selectedSoftwareLogos, setSelectedSoftwareLogos] = useState([]);
    const [otpCheck,setOtpCheck] = useState(false);
    const [open, setOpen] = useState(false)
    const [profilePic, setProfilePic] = useState(null);
    const navigate = useNavigate();
    const { profileType, selectedCountry } =  useContext(AppContext);
    const initialValues = {
        Email: "",
        Password: "",
        Name: "",
        ShortBio: "",
        ProfessionPositionName: "",
        EducationalInstitute1: "",
        EducationTitle1: "",
        EducationDegree1: "",
        EducationYear1: null,
        EducationalInstitute2: "",
        EducationTitle2: "",
        EducationDegree2: "",
        EducationYear2: null,
        EducationalInstitute3: "",
        EducationTitle3: "",
        EducationDegree3: "",
        EducationYear3: null,
        CompanyProfessionalExperience1: "",
        PositionProfessionalExperience1: "",
        YearProfessionalExperience1: null,
        CompanyProfessionalExperience2: "",
        PositionProfessionalExperience2: "",
        YearProfessionalExperience2: null,
        CompanyProfessionalExperience3: "",
        PositionProfessionalExperience3: "",
        YearProfessionalExperience3: null,
        StartYear: null,
        WebsiteLink: "",
        ContactEmailAddress: "",
        ContactPhoneNumber: null,
        ProfilePicture: "",
        MagazineShippingAddress: "",
        OperationRange: "",
        FacebookIconLink: "",
        InstagramIconLink: "",
        IssueIconLink: "",
        XIconLink: "",
        YoutubeIconLink: "",
        Occupation: "",
        Concentration: "",
        Industry: "",
        SoftwareLogo: [],
        showOtherInfo: false,
    };

    const validationSchema = Yup.object({
        Email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        Password: Yup.string().required("Password is required"),
    });

    useEffect(() => {
        if (!profileType) {
            navigate("/pricing");
        }
    }, [profileType, navigate]);


    const handleSubmit = async (values, { setSubmitting }) => {
        console.log('test');
        if (!otpCheck) {
            toast.error("Please verify your email before submitting the form");
            setSubmitting(false)
            return;
          }
        try {
            const selectedCountryId = selectedCountry;
            values.ProfilePicture = profilePic;
            values.Country = {
                countryId: parseInt(selectedCountryId),
            };
            values.SoftwareLogo = selectedSoftwareLogos;
            values.Occupation = profileType;
            const response = await registerUser(values);
            if (response.header.code === 0) {
                toast.error("Please fill required fields");
            } else {
                toast.success("Account created successfully");
                navigate("/login");
            }

        } catch (error) {
            console.error("Submission error:", error);
            toast.error(error.message || "Something went wrong");
        } finally {
            setSubmitting(false);
        }
    };


    const handleImageUpload = async (event) => {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

        if (event.target.files[0]) {
            const file = event.target.files[0];

            if (allowedTypes.includes(file.type)) {
                try {
                    const s3Link = await uploadAdapter(file);
                    setProfilePic(s3Link);
                } catch (error) {
                    console.error("Error uploading image to S3:", error);
                    toast.error("Something went wrong while uploading the image.");
                }
            } else {

                toast.error("Only JPG, PNG, and JPEG images are allowed.");
                event.target.value = null;
            }
        }
    };

    return (
        <>
            <div className="px-10 py-10">
                <div className="bg-gray-100 px-10 min-h-screen rounded-lg">
                    <div className="py-10 flex flex-col items-center gap-4 justify-center">
                        <img src={logo} alt="Balarch Logo" className="w-40" />
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting, values }) => (
                                <Form>

                                    <PersonalInfo
                                        isSubmitting={isSubmitting}
                                        handleImageUpload={handleImageUpload}
                                        values={values}
                                        otpCheck={otpCheck}
                                        setOtpCheck={setOtpCheck}
                                    />
                                    <ProfessionalInfo />
                                    {
                                        profileType !== "Company" &&
                                        profileType !== "Product" && (
                                            <>
                                                <EducationInfo />
                                                <SoftwareExperience
                                                    selectedSoftwareLogos={selectedSoftwareLogos}
                                                    setSelectedSoftwareLogos={setSelectedSoftwareLogos}
                                                />
                                            </>
                                        )}


                                    <ContactInfo />
                                    <OtherInfo />

                                    <div className="flex justify-between">
                                        <div class="flex items-center">
                                            <input id="link-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                            <label for="link-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">I have read the <Link onClick={() => setOpen(true)} class="text-blue-600 dark:text-blue-500 hover:underline">terms and conditions</Link>.</label>
                                        </div>
                                        <button
                                            type="submit"
                                            disabled={isSubmitting}
                                            className="text-white float-right bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-3 py-2 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                        >
                                            {isSubmitting ? "Signing in..." : "Sign In"}
                                        </button>
                                    </div>


                                    <div className="text-center mt-10">
                                        <span className="text-xs font-semibold text-gray-900">
                                            <span>Already have an account?</span>
                                            <Link
                                                to="/login"
                                                className="inline-block ml-1 text-sky-500 font-bold hover:text-orange-700"
                                            >
                                                Log In
                                            </Link>
                                        </span>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
            <TermsAndCondition open={open} setOpen={setOpen} />
        </>
    );
};

export default Register;
